import React from 'react';

import { formatMoney } from '@betterment/core';
import { Box, Icon, Separator, Text } from '@betterment/samba-react';

import { PurposeAccountsCardQuery } from '../../graphql/purposeAccountsCard.generated';

type ManagedAccount = Extract<
  PurposeAccountsCardQuery['purpose']['envelope']['accounts'][number],
  { __typename: 'ManagedAccount' }
>;

export const ManagedSubAccountRows: React.FC<{ account: ManagedAccount }> = ({ account }) => {
  const { subAccounts, recurringTransactionConfigs } = account;

  const showRecurringIcon = (subAccountId: string) =>
    recurringTransactionConfigs.map(config => config.destination.id).includes(subAccountId);

  return (
    <Box>
      {subAccounts.map((subAccount, index) => (
        <React.Fragment key={subAccount.id}>
          {index > 0 && <Separator css={{ my: 'space.200' }} />}
          <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text variant="text50" color="text.weak">
              {subAccount.name}
            </Text>
            <Box css={{ display: 'flex', gap: 'space.50', alignItems: 'stretch' }}>
              {showRecurringIcon(subAccount.id) && (
                <Icon color="icon.weak" name="ArrowCircle" size="xxsmall" data-testid="recurringTransactionIcon" />
              )}
              <Text variant="text50" color="text.weak">
                {formatMoney(subAccount.balance)}
              </Text>
            </Box>
          </Box>
        </React.Fragment>
      ))}
    </Box>
  );
};
